import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { translations } from '@/i18n';
import { fetchUserGeo } from '@/lib/geo';
import SEO from '@/components/SEO';
import Hero from '@/components/Hero';
import Products from '@/components/Products';
import Credentials from '@/components/Credentials';
import BrandSeal from '@/components/BrandSeal';
import About from '@/components/About';
import Technologies from '@/components/Technologies';
import Stats from '@/components/Stats';
import Blog from '@/components/Blog';
import ContactSection from '@/components/ContactSection';

const LandingPage = ({ lang }) => {
  const t = translations[lang];
  const location = useLocation();
  const [userGeo, setUserGeo] = useState(null);

  useEffect(() => {
    let active = true;
    fetchUserGeo().then((g) => { if (active) setUserGeo(g); });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const target = document.getElementById(id);
      if (target) {
        setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location]);

  const seal1 = {
    kicker: '// CAURATECH · CONFIDENTIAL TECH PARTNER',
    tagline: lang === 'es' ? 'Tu identidad secreta tecnológica.' : 'Your secret tech identity.',
  };
  const seal2 = {
    kicker: lang === 'es' ? '// AVANZA AL FUTURO · SINCE 2016' : '// ADVANCE TO THE FUTURE · SINCE 2016',
    tagline: lang === 'es' ? '¡Bienvenido al Futuro!' : 'Welcome to the Future!',
  };

  return (
    <main data-testid="landing-main">
      <SEO
        lang={lang}
        path="/"
        title={lang === 'es' ? 'Tu identidad secreta tecnológica' : 'Your secret tech identity'}
        description={lang === 'es'
          ? 'Confidential Tech Partner desde 2016. Plataformas a medida, IA aplicada, seguridad gov-grade, blockchain y soluciones bancarias para clientes de alto perfil.'
          : 'Confidential Tech Partner since 2016. Custom platforms, applied AI, gov-grade security, blockchain and banking solutions for high-profile clients.'}
      />
      <Hero lang={lang} t={t} userGeo={userGeo} />
      <Products lang={lang} t={t} />
      <Credentials lang={lang} t={t} />
      <BrandSeal variant="horizontal" kicker={seal1.kicker} tagline={seal1.tagline} testId="brand-seal-1" />
      <About lang={lang} t={t} />
      <Technologies lang={lang} t={t} />
      <Stats lang={lang} t={t} />
      <BrandSeal variant="isologo" kicker={seal2.kicker} tagline={seal2.tagline} testId="brand-seal-2" />
      <Blog lang={lang} t={t} />
      <ContactSection lang={lang} t={t} />
    </main>
  );
};

export default LandingPage;
